import * as Sentry from '@sentry/nextjs'
import { RecurlyAccount, BillingInfo } from '../../types/types'
import React, { useEffect, useState } from 'react'
import {
  getRecurlyAccount,
  removeBillingDetails,
  updatePaymentInfo,
} from '../../services/SubscriptionApiClient'

import { AddPaymentDetailsForm } from './AddPaymentDetailsForm'
import CardInfoComponent from '../Subscription/CardInfoComponent'
import { RecurlyError, TokenPayload } from '@recurly/recurly-js'
import { ThreeDSecureActionModal } from './ThreeDSecureActionModal'

interface propTypes {
  billingInfo?: BillingInfo
  setAccount: Function
  togglePaymentForm: Function
  account: RecurlyAccount
}

export const EditPaymentDetailsComponent = (props: propTypes) => {
  const { setAccount, billingInfo, togglePaymentForm, account } = props
  const [threeDSecureActionToken, setThreeDSecureActionToken] = useState('')
  const [billingInfoToken, setBillingInfoToken] = useState('')

  const deleteBillingDetails = async () => {
    await removeBillingDetails()
    setAccount(await getRecurlyAccount())
  }

  async function handleThreeDSecureToken(token: string) {
    await updatePaymentInfo(billingInfoToken, token)
    setAccount(await getRecurlyAccount())
    togglePaymentForm(false)
  }

  async function updateBillingInfo(token: TokenPayload) {
    setBillingInfoToken(token.id)
    const paymentInfo = await updatePaymentInfo(token.id)
    if (
      paymentInfo.error &&
      paymentInfo.threedsActionRequired &&
      paymentInfo.threedsToken
    ) {
      setThreeDSecureActionToken(paymentInfo.threedsToken)
    } else if (paymentInfo.error) {
      Sentry.captureException(
        `Uncaught error when updating payment info: ${paymentInfo.error}`
      )
      throw {"message": `Unexpected error when updating payment info: ${paymentInfo.error}`} as Error
    } else {
      setAccount(await getRecurlyAccount())
      togglePaymentForm(false)
    }
  }

  return (
    <>
      {billingInfo ? (
        <>
          <div className="mb-20">
            <strong>Your saved billing details</strong>
          </div>
          <div className="d-flex">
            <CardInfoComponent billingInfo={billingInfo} />
            <div className="d-flex align-items-center ml-20">
              <small
                className="text-danger cursor-pointer"
                onClick={() => deleteBillingDetails()}
              >
                <i className="fa fa-times"></i> Remove billing details
              </small>
            </div>
          </div>
        </>
      ) : (
        <>
          <AddPaymentDetailsForm
            onSubmit={(token) => updateBillingInfo(token)}
            setAccount={setAccount}
            togglePaymentForm={togglePaymentForm}
            account={account}
          />
          <ThreeDSecureActionModal
            actionTokenId={threeDSecureActionToken}
            onResultToken={handleThreeDSecureToken}
            onClose={() => setThreeDSecureActionToken('')}
          />
        </>
      )}
    </>
  )
}
